module.exports = __webpack_public_path__ + "static/img/yzzzpic.50ce320.png";


//////////////////
// WEBPACK FOOTER
// ./src/summary/assets/images/yzzzpic.png
// module id = JIYC
// module chunks = 166